import { Injectable } from '@angular/core';
import { AppInitService } from 'src/app/app-init.service';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';

@Injectable({
  providedIn: 'root'
})
export class ExternalRouteServiceService {

  appConfig!: AppConfigurations;

  constructor(private appInitService: AppInitService) {
    appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onReceiveAppConfig(config)
    })
  }

  private _onReceiveAppConfig(appConfig: AppConfigurations) {
    this.appConfig = appConfig
  }

  routeToAcAppointmentConfirmation(cnCode: string) {
    window.open(`${this.appConfig.ac.appointmentWidegetUrlForCnCode}${cnCode}`, '_blank');
  }
}
